import firebase from 'firebase/app'
import 'firebase/firestore'
import NumberHelpers from '../helpers/NumberHelpers'
import Firestore from './Firestore'
import AlertHelpers from '../helpers/AlertHelpers'
import Security from './Security'

var fs = firebase.firestore()

export default class {
    static fetchDocument(docPath, id) {
        return new Promise( (resolve, reject) => {
            const ref = fs.doc(docPath + '/' + id)
            ref.get().then(doc => {
                
                if(doc.exists) {
                    resolve({
                        ...doc.data(),
                        _id: doc.id,
                        _path: docPath
                    })
                }
                else {
                    resolve(null)
                }
            }).catch(err => {
                AlertHelpers.showAlert(err.message)
                console.log('Error during fetchDocument', err)
                reject(err.message)
            })
        })
    }

    /* 
        options: {
            where: [ {field: 'field', operator: '==', value: 'value'}, ...],
            limit: 100,
        }

    */


    static fetchCollection(collectionPath, options = {}) {
        return new Promise( async(resolve, reject) => {
            let ref = fs.collection(collectionPath)
            const whereArr = options.where || []
            whereArr.forEach(where => {
                ref = ref.where(where.field, where.operator, where.value)
            })
            
            ref.get().then(snap => {
                const arr = []
                snap.forEach(doc => {
                    let newItem = doc.data()
                    newItem._id = doc.id
                    newItem._path = collectionPath
                    arr.push(newItem)
                })
                resolve(arr)
            })
        })
    }

    static fetchDocumentByCode(collectionPath, code) {
        return new Promise( async (resolve, reject) => {
            const items = await this.fetchCollection(collectionPath, {where: [{field:'code', operator: '==', value: code}]})   
            if(items && items.length)
                resolve(items[0])
            else         
                resolve(null)
        })
        
    }

    static saveDocument(doc) {  
        const docPath = doc._path + '/' + doc._id
        doc = prepareItemForStorage(doc)
        const ref = fs.doc(docPath)
        console.groupCollapsed('saveDocument')
        console.log('saveDocument', doc)
        console.log(this.getConsolePath(docPath))
        console.groupEnd()
        ref.set(doc, {merge: true})
    }

    static newId() {
        return fs.collection('teams').doc().id
    }

    static me() {
        return firebase.auth().currentUser
    }

    static getConsolePath (docPath) {
        const base = 'https://console.firebase.google.com/u/0/project/photon-6d209/firestore/data'
        return base + (docPath ? '/' + docPath : '')
    }


} // end class

const prepareItemForStorage = function(obj) {
    let newObj = Object.assign({}, obj)
    for(let prop in newObj) {
        if(prop.substr(0,1) == '_')
            delete newObj[prop]
    }
    return newObj
}


// WEBPACK FOOTER //
// ./src/data/Db1.js